<template>
    <div class="tab_content">
        <div class="search_box clearfix">
            <div class="search_time search_inputBox">
               <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
               ~
               <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <!-- <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.brand_id" clearable placeholder="品牌" @visible-change="getBrandList">
                <el-option v-for="list in brandList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.breed_id" clearable placeholder="品名" @visible-change="getBreedList">
                <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.grade_id" clearable placeholder="等级" @visible-change="getGradeList">
                <el-option v-for="list in gradeList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->

            <el-input class="search_input search_inputBox" v-model="params.search.contract_no" clearable placeholder="合同号"></el-input>
            <div class="reset fcolor" @click="reset">重置</div>
            <el-button  class="publicBtn" @click="search">查询</el-button>
            <div class="execlInsert">
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"></tabletem>
        </div>
        <div class="text-center">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- <div class="totalCal">
            <div class="totalName">合计：</div>
            <div class="totalNumber">件数:{{ statistics.count }}件</div>
            <div class="totalNumber">销售方数：{{ statistics.sales_cube }}</div>
            <div class="totalNumber">总金额：{{ statistics.sales_amount }}</div>
        </div> -->
    </div>
</template>
<style scoped lang="scss">
    .container{ }
</style>
<script>
import tabletem from '../../../components/table.vue'
import pagination from '../../../components/pagination.vue'
    export default {
        components:{
            tabletem,
            pagination
        },
        data(){
            return{
                tableLoading:false,
                start_time: "",
                end_time: new Date(),
                params : {
                    page : 1,
                    per_page : 50,
                    search:{
                        contract_no : "",
                        sales_start:"",
                        sales_end:""
                    }
                },
                last_page : 1,
                current_page : 1,
                total:0,
                statistics : {
                    count  : "",
                    sales_cube  : "",
                    sales_amount  : "",
                },

                list:[],
                tableCol:[
                    // {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"入库数量",colKey:"in_count",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"销售出库数量",colKey:"out_count",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"销售金额",colKey:"sales_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"剩余码单立方",colKey:"remain_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},

                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"入库合同立方",colKey:"in_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售出库立方",colKey:"out_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"剩余库存立方",colKey:"remain_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
            }
        },
        mounted(){
            this.start_time = this.$getCurrentMonthStartValueOf();
            // this.end_time = this.$getCurrentMonthEndtValueOf();
        },
        methods:{
            exportExcelBill(){
                this.$exportExecl("/erp/export.summarizing.sales.contract","销售汇总(合同)",this.params)
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.$axios.post("/erp/report.order.contract",this.params).then((response) => {
                    if(response.data.code == 0){
                        this.list = response.data.data.list;
                        this.list.forEach(item => {
                            item.in_count = this.keepLimit(Number(item.in_count))
                            item.out_count = this.keepLimit(Number(item.out_count))
                            item.sales_amount = this.keepPrice(Number(item.sales_amount))
                            item.remain_cube = this.keepLimit(Number(item.remain_cube))
                        })
                        this.total = response.data.data.total;
                        // this.statistics = response.data.data.statistics;
                        this.last_page = response.data.data.last_page;
                    }
                }).catch((error) => {
                    window.console.log(error);
                })
            },
            search(){
                this.params.search.sales_start = this.formatTimeZero(this.start_time)
                this.params.search.sales_end = this.formatTimeZero(this.end_time)
                if(this.params.page == 1){
                    this.getList();
                } else {
                    this.params.page = 1
                }
            },
            reset(){
                this.start_time = "";
                this.end_time = '';
                this.params.search = {
                    contract_no : "",
                    sales_start:"",
                    sales_end:""
                }
                this.search();
            },
            // 品名
            getBreedList(visible){
                if(visible){
                    this.$getBreedList().then(res=>{
                        this.breedList = res.data.data;
                    })
                }
            },
            // 品牌
            getBrandList(visible){
                if(visible){
                    this.$getBrandList().then(res=>{
                        this.brandList = res.data.data;
                    })
                }
            },
            // 等级
            getGradeList(visible){
                if(visible){
                    this.$getGradeList().then(res=>{
                        this.gradeList = res.data.data;
                    })
                }
            },

        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            }
        }
    }
</script>
